import React from "react";
import PropTypes from "prop-types";

import NotificationsFooter from "apps/notifications_footer";
import OkPhotoUploader from "shared/components/OkPhotoUploader";
import ProfileQuickview from "shared/components/ProfileQuickview";

const AuthedGlobalElements = ({ userid }) => {
	return (
		<>
			<NotificationsFooter userid={userid} />
			<OkPhotoUploader userid={userid} />
			<ProfileQuickview />
		</>
	);
};

AuthedGlobalElements.propTypes = {
	userid: PropTypes.string.isRequired,
};

export default AuthedGlobalElements;



// WEBPACK FOOTER //
// ./src/routers/Desktop/AuthedGlobalElements.jsx